import React, { Component } from 'react'

export default class SecondDiv extends Component {
  render() {
    return (
      <div className='second-div'>
        <h3>Education</h3>
        <a href='#'>Offer for students and teachers<i class='bx bx-chevron-right'></i></a>
        <a href='#'>About for the Classroom<i class='bx bx-chevron-right'></i></a>
        <a href='#'>Ableton for Colleges and Universities<i class='bx bx-chevron-right'></i></a>
      </div>
    )
  }
}
